<template>
  <div>
    <el-dialog
      title="邀请人"
      :visible.sync="dialogVisible"
      width="740px"
      :before-close="handleClose"
    >
      <div class="dl-page">
        <div class="search-layout">
          <div class="item-wrap">
            <el-input
              size="small"
              placeholder="业务人员ID"
              v-model="formIn.salesJobNumber"
            />
          </div>
          <div class="item-wrap op">
            <el-button size="small" @click="resetForm">重置</el-button>
            <el-button type="primary" size="small" @click="handleSearch">
              搜索
            </el-button>
          </div>
        </div>
        <div class="remarks" style="margin-top: 12px">
          说明：关系树的上方邀请了下方。例如000001号业务员邀请000002号业务员，则000001在000002上方。
        </div>
        <div class="table-wrap v-gap-small">
          <div class="scroll-content">
            <div class="list">
              <div class="list-row header">
                <div class="list-line">
                  <div class="up"></div>
                  <div class="dot"></div>
                  <div class="down"></div>
                </div>
                <div class="list-cell">业务人员ID</div>
                <div class="list-cell">业务人员手机号</div>
                <div class="list-cell">姓名</div>
              </div>
            </div>
            <div class="list scroll-content">
              <div
                :class="{
                  'list-row body': true,
                  focus: index === selectedIndex,
                }"
                v-for="(item, index) in tableData"
                :key="index"
              >
                <div class="list-line">
                  <div class="up"></div>
                  <div class="dot"></div>
                  <div class="down"></div>
                </div>
                <div class="list-cell">{{ item.salesJobNumber }}</div>
                <div class="list-cell">{{ item.contactInformation }}</div>
                <div class="list-cell">{{ item.salesUserName }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="right">
          <el-button @click="handleClose" size="small">取 消</el-button>
        </div>
      </span>
    </el-dialog>

    <SelectSalesman ref="refSelectSalesman" />
  </div>
</template>
<script>
import SelectSalesman from "./SelectSalesman.vue";
import { getSalesUserParentInformationBySalesId } from "@/api/externalSalesRule/index.js";
import _ from "lodash";

export default {
  components: { SelectSalesman },
  props: {},
  computed: {
    headers: function () {
      return {
        Authorization: "Bearer " + getToken(),
      };
    },
  },
  data() {
    return {
      dialogVisible: false,
      formIn: {
        salesJobNumber: "",
      },

      selectedIndex: -1,
      tableData: [],
    };
  },
  methods: {
    handleClientTrans() {
      this.selection = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    init() {
      //
    },
    resetForm() {
      for (let key in this.formIn) {
        this.formIn[key] = "";
      }
    },
    handleSearch() {
      this.getList();
    },
    getList() {
      const params = {
        id: this.rowData.id,
      };
      _.merge(params, this.formIn);
      getSalesUserParentInformationBySalesId(params).then((data) => {
        if (data && data.length > 0) {
          this.tableData = data;
          this.selectedIndex = this.tableData.findIndex(
            (item) => item.salesJobNumber === this.rowData.salesJobNumber
          );
        } else {
          this.tableData = [];
        }
      });
    },
    clear() {
      for (let key in this.formIn) {
        this.formIn[key] = "";
      }
      this.selectedIndex = -1;
      this.rowData = null;
      this.tableData = [];
    },
    open(row) {
      this.clear();
      this.dialogVisible = true;

      this.rowData = _.cloneDeep(row);

      this.getList();
    },
  },
};
</script>
<style scoped lang="scss">
@import "../style/index.scss";
.scroll-content {
  height: 100%;
  display: flex;
  flex-direction: column;

  .list {
    display: flex;
    flex-direction: column;

    .list-row {
      display: flex;
      //align-items: center;

      .list-line {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-shrink: 0;
        width: 24px;

        // align-items: stretch;

        .up,
        .down {
          flex: 1;
          width: 1px;
          background: #ffe4e6;
          flex-shrink: 0;
        }

        .dot {
          width: 11px;
          height: 11px;
          background: #f6212d;
          border-radius: 50%;
        }
      }

      .list-cell {
        width: 160px;
        padding: 12px;
        box-sizing: border-box;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      &.header {
        .list-line {
          visibility: hidden;
        }
      }
      &.body {
        &:nth-child(1) {
          .up {
            visibility: hidden;
          }
        }

        &:last-child {
          .down {
            visibility: hidden;
          }
        }

        &.focus {
          .dot {
            background: #f6212d;
            position: relative;
            box-shadow: 0 0 0 6px rgba($color: #f6212d, $alpha: 0.1);
          }
          .list-cell {
            color: #f6212d;
          }
        }
      }
    }

    &.scroll-content {
      flex: 1;
      overflow: auto;
    }
  }
}
</style>
